export default __webpack_public_path__ + "assets/png/fbc18da75b077c6452c5d6fc4e225dbe.png";